import React from 'react';
import { IconProps } from './types';

const Airspaces = (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.5 17.5" {...props}>
        <path
            fill="currentColor"
            d="M8.75 0C3.93 0 0 3.93 0 8.75s3.93 8.75 8.75 8.75 8.75-3.93 8.75-8.75S13.57 0 8.75 0Zm0 1.5c3.73 0 6.81 2.83 7.2 6.46h-3.54A3.752 3.752 0 0 0 8.75 5C6.68 5 5 6.68 5 8.75c0 .67.19 1.29.5 1.84l-2.58 2.45A7.17 7.17 0 0 1 1.5 8.75c0-4 3.25-7.25 7.25-7.25ZM6.5 8.75c0-1.24 1.01-2.25 2.25-2.25S11 7.51 11 8.75 9.99 11 8.75 11 6.5 9.99 6.5 8.75ZM8.75 16c-1.85 0-3.54-.7-4.82-1.85l2.56-2.43c.63.48 1.41.78 2.26.78 1.82 0 3.34-1.31 3.68-3.04h3.54C15.61 13.13 12.51 16 8.76 16Z"
        />
    </svg>
);

export default Airspaces;
